export default "__VITE_ASSET__fdfd8170__"